module.exports = __webpack_public_path__ + "img/site_08_bak.e9b25ae2.png";